'use client';

import { faTrash } from '@fortawesome/pro-light-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { IconButton } from '@/components/ui/icon-button/icon-button.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { CartItem } from '@/types/cart.types';
import { getCartItemPrice, hasCartItemDiscount } from '@/utils/cart/get-cart-total.util';
import { currencyFormatter } from '@/utils/formatters/currency';

interface CartLaboratoryExamProps {
  item: CartItem;
  onRemove?: () => void;
}

export function CartLaboratoryExam({ item, onRemove }: CartLaboratoryExamProps) {
  const originalPrice = hasCartItemDiscount(item) ? item.price : undefined;
  const hasDiscount = originalPrice !== undefined;

  return (
    <div
      className="flex w-full items-start gap-3"
      data-testid={DataTestIdEnum.CART_LABORATORY_GROUP_EXAM}
    >
      <div className="flex min-w-0 flex-1 flex-col">
        <Typography
          className="text-base leading-6 text-gray-700"
          data-testid={DataTestIdEnum.CART_LABORATORY_GROUP_EXAM_NAME}
        >
          {item.procedure.name}
        </Typography>

        <div className="flex flex-wrap items-center gap-1">
          <Typography
            className={`text-base font-bold leading-6 ${hasDiscount ? 'text-pink-700' : 'text-gray-700'}`}
            data-testid={DataTestIdEnum.CART_LABORATORY_GROUP_EXAM_PRICE}
          >
            {currencyFormatter(getCartItemPrice(item))}
          </Typography>

          {hasDiscount && (
            <Typography
              className="text-xs font-light leading-4 text-gray-700 line-through"
              data-testid={DataTestIdEnum.CART_ITEM_ORIGINAL_PRICE}
            >
              {currencyFormatter(originalPrice)}
            </Typography>
          )}
        </div>
      </div>

      {onRemove && (
        <IconButton
          size="lg"
          icon={faTrash}
          label={`Remover ${item.procedure.name}`}
          onClick={onRemove}
          iconClassName="text-green-500 group-active:text-green-600"
          data-testid={DataTestIdEnum.CART_LABORATORY_GROUP_EXAM_REMOVE_BUTTON}
        />
      )}
    </div>
  );
}
